<template>
  <ValidationObserver ref="form">
    <form @submit.prevent="validate">
      <div style="width: 100%">
        <ServiceInfo></ServiceInfo>
        <div class="col-md-10 m-auto jipvio-rad onlyContrAgree">
          <div class="">
            <card class="mt-15">
              <h3 class="jipvio-text-center">서비스 이용 약관</h3>
              <h5>
                <ul style="padding:0;">
                  본 정책은 '집비오' 플랫폼에서 부동산의 허위매물을 원천
                  차단하고, 전문적이고 신뢰성있는 부동산 중개 문화 활성화를
                  목적으로 합니다.
                  <li class="pb-10">
                    1. 공인중개사 회원은 공인중개사법과 관련 법령을 준수하며,
                    '집비오'의 운영 정책 및 관리 규정을 이행하여야 합니다.
                  </li>
                  <li class="pb-10">
                    2. 공인중개사 회원은 공인중개사 업무 및 부동산 거래신고에
                    관한 법률(이하 공인중개사법)에 따른 중개업신고 및 개성등록이
                    확인된 사용자만이 서비스를 이용 할 수 있습니다.
                  </li>
                  <li class="pb-10">
                    3. 공인중개사 회원의 경우 의무 조항을 어길 시, 서비스 이용이
                    제한될 수 있으며 이에 따른 불이익은 회사가 책임지지
                    않습니다.
                  </li>
                  <li class="pb-10">
                    4. 휴업, 폐업, 상호명 변경, 중개사무소 소재지변경 등 사업자
                    정보 변경 시 즉각 '집비오부동산중개'에 이를 고지하고
                    변경해야 합니다.
                  </li>
                  <li class="pb-10">
                    5. 개업공인중개사는 거래당사자에게 신의를 지키고
                    성실·공정하게 중개업무를 수행해야 합니다.
                  </li>
                </ul>

                <ul style="padding:0;">
                  &lt;매물 등록 약관&gt;
                  <li class="pb-10">
                    1. ‘집비오’는 한 명의 공인중개사에게만 의뢰하는
                    전속중개계약을 체결한 매물만 플랫폼에 노출합니다.
                  </li>
                  <li class="pb-10">
                    2. 등록한 매물은 전속중개계약서와 건축물대장 소유자 확인을
                    거쳐, 최종 노출합니다.
                  </li>
                  <li class="pb-10">
                    3. 전속중개계약을 체결한 매물을 등록하시면, ‘집비오’의 광고
                    서비스를 무료로 이용하실 수 있습니다.
                  </li>
                  <li class="pb-10">
                    4. 공인중개사법 제23조제2항의 규정에 따른 전속중개계약서는
                    별지 제15호의 서식을 따릅니다. (공인중개사법 제14조)
                  </li>
                  <li class="pb-10">
                    5. 계약이 체결된 매물은 즉시 ‘계약완료’ 상태로 변경해야
                    합니다.
                  </li>
                </ul>
              </h5>
              <div class="jipvio-text-right">
                <p>'개업공인중개사'는 상기 내용에 동의합니다.</p>
                <ValidationProvider ref="svcAgrmtYnVal" rules="required|true">
                  <!-- <fg-input ref="svcAgrmtYnBox" innerRef="svcAgrmtYnBox_inner"> -->
                  <fg-input>
                    <el-checkbox
                      ref="svcAgrmtYnBox"
                      label="동의"
                      v-model="svcAgrmtYn"
                      @change="allYnFalse()"
                    ></el-checkbox>
                  </fg-input>
                </ValidationProvider>
              </div>
            </card>
          </div>

          <div class="">
            <card class="mt-15">
              <h3 class="jipvio-text-center">개인정보 수집 및 이용 동의</h3>
              <h4>1. 개인정보의 수집 및 이용목적</h4>
              <h5>
                개인정보의 수집은 다음과 같은 목적을 위하여 수집하며, 이외의
                목적으로는 사용되지 않습니다.
                <ul class="ul-no-deco" style="padding:0;">
                  <li>-부동산 거래를 위한 계약서 작성</li>
                  <li>-고객관리</li>
                </ul>
              </h5>

              <h4>2. 수집하는 개인정보의 항목</h4>
              <div class="mt-10 mb-10">
                <el-table :data="tableData" size="medium" border>
                  <el-table-column
                    prop="purpose"
                    label="수집목적"
                  ></el-table-column>
                  <el-table-column
                    prop="category"
                    label="수집항목"
                  ></el-table-column>
                  <el-table-column
                    prop="period"
                    label="보유 및 이용기간"
                  ></el-table-column>
                </el-table>
              </div>
              <h4>3. 개인정보의 보유 및 이용 기간</h4>
              <h5>
                저장된 개인정보는 원칙적으로 개인정보의 수집 및 이용목적이
                달성되면 지체없이 파기합니다. 단, 다음의 정보에 대해서는 명시한
                기간 동안 보존합니다.
              </h5>
              <h5>
                (1) 관련법령에 의한 정보 보유사유
                <br />상법, 전자금융거래법 등 관련법령의 규정에 의하여 보존할
                필요가 있는 경우 관계법령에서 정한 일정한 기간동안 개인정보를
                보관합니다. 이 경우 보관하는 정보를 그 보관의 목적으로만
                이용하며 보존기간은 아래와 같습니다.
                <ul class="ul-no-deco" style="padding:0;">
                  <li>
                    - 이 부동산 계약서 거래 기록 보존 이유: 공인중개사법 시행령
                    제22조
                  </li>
                  <li>- 보존기간: 5년</li>
                </ul>
              </h5>
              <h5>
                (2) 고객관리의 개인정보는 고객의 파기 요청이 있을 때 까지 보존
              </h5>

              <h4>
                4. 개인정보 수집 및 이용에 대해 거부할 권리가 있으며, 위 항목
                등의 거부 시 서비스 이용이 어려워질 수 있습니다.
                <br />
              </h4>
              <h5>
                개인정보 수집/보관 의무를 수행하지 않아 발생된 모든 책임은 해당
                개업공인중개사 및 중개사무소에 있습니다.
              </h5>

              <div class="jipvio-text-right">
                <p>정보주체는 상기 내용에 동의합니다.</p>
                <ValidationProvider ref="privacyYnVal" rules="required|true">
                  <fg-input>
                    <el-checkbox
                      ref="privacyYnBox"
                      label="동의"
                      v-model="privacyYn"
                      @change="allYnFalse()"
                    ></el-checkbox>
                  </fg-input>
                </ValidationProvider>
              </div>
            </card>
            <div class="mt-15 jipvio-text-right">
              <el-checkbox
                label="전체동의"
                v-model="allYn"
                @change="allCheck()"
              ></el-checkbox>
            </div>
            <p class="jipvio-text-center">
              ※ 상기내용을 충분히 확인하고, 이에 동의 후 전속중개계약 체결을
              진행합니다.
            </p>
            <div class="jipvio-text-center">
              <el-button
                class="jipvio-btn1"
                type="primary"
                @click="emitForNext()"
                >동의</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>
<script>
import ServiceInfo from "@/pages/jipvio/GeneralViews/ServiceInfoForAgt.vue";
import { extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import { createNamespacedHelpers } from "vuex";

extend("required", required);
extend("true", value => {
  return value == true;
});

import {
  Card,
  Checkbox,
  Table,
  TableColumn,
  Button,
  Message
} from "element-ui";

const {
  mapActions: sessionMapActions,
  mapGetters: sessionMapGetters
} = createNamespacedHelpers("loginSession");

export default {
  components: {
    ServiceInfo,
    Card,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  data() {
    return {
      svcAgrmtYn: null,
      privacyYn: null,
      allYn: null,

      tableData: [
        {
          purpose: "계약서",
          category: "(선택)성명, 주민번호, 전화번호, 주소",
          period: "5년(공인중개사법 시행령 제22조)"
        },
        {
          purpose: "고객관리",
          category:
            "(필수) 고객명, 전화번호, 고객구분 " +
            "\n" +
            "(선택) 매물종류, 거래종류, 주소",
          period: "고객의 파기 요청시 까지"
        }
      ]
    };
  },
  created() {
    console.log("agtFirst!");
    console.log(this.sessionPropertyInquiry);
    this.svcAgrmtYn = this.sessionPropertyInquiry.agreement.svcAgrmtYn;
    this.privacyYn = this.sessionPropertyInquiry.agreement.privacyYn;
  },

  computed: {
    ...sessionMapGetters({
      sessionPropertyInquiry: "getPropertyInquiry"
    })
  },

  methods: {
    ...sessionMapActions(["saveAgtPropertyInquiryStep1"]),
    saveStep1Info() {
      console.log("Agt step1 Action!");
      const agreement = {
        svcAgrmtYn: this.svcAgrmtYn,
        privacyYn: this.privacyYn
      };
      this.saveAgtPropertyInquiryStep1(agreement);
      console.log(this.sessionPropertyInquiry);
    },

    async showMessage() {
      let errMsg = [];

      let res = await this.$refs["svcAgrmtYnVal"].validate();
      if (!res.valid) {
        errMsg.push({
          message: "서비스 이용 약관에 동의해주세요.",
          ref: "svcAgrmtYnBox",
          IsfocusRequireEl: true
        });
      }

      res = await this.$refs["privacyYnVal"].validate();
      if (!res.valid) {
        errMsg.push({
          message: "개인정보 수집 및 이용에 동의해주세요.",
          ref: "privacyYnBox",
          IsfocusRequireEl: true
        });
      }

      if (errMsg[0] != null) {
        if (errMsg[0].IsfocusRequireEl == true) {
          this.$refs[errMsg[0].ref].$el.focus();
        } else {
          this.$refs[errMsg[0].ref].focus();
        }
        Message({
          message: errMsg[0].message,
          type: "error"
        });
      }

      if (errMsg[1] != null) {
        Message({
          message: errMsg[1].message,
          type: "error",
          offset: 60
        });
      }
    },

    validate() {
      console.log(this.$refs.form);
      return this.$refs.form.validate().then(res => {
        if (!res) {
          this.showMessage();
          return;
        }
        this.$emit("on-validated", res);
        this.scrollToTop();
        this.saveStep1Info();
        return res;
      });
    },

    scrollToTop() {
      window.scrollTo(0, 0);
    },

    allCheck() {
      if (this.allYn == true) {
        this.privacyYn = true;
        this.svcAgrmtYn = true;
      } else {
        this.privacyYn = false;
        this.svcAgrmtYn = false;
      }
    },

    allYnFalse() {
      if (this.privacyYn == false || this.svcAgrmtYn == false) {
        this.allYn = false;
      }
    },
    emitForNext() {
      this.$root.$emit("agt_step1_agree");
    }
  }
};
</script>
<style></style>
